import { render, staticRenderFns } from "./ProductCollectionInput.vue?vue&type=template&id=ae6f85a6&scoped=true&"
import script from "./ProductCollectionInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProductCollectionInput.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProductCollectionInput.vue?vue&type=style&index=0&id=ae6f85a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6f85a6",
  null
  
)

export default component.exports